function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 7.993l-6.54-.422L9.994 1.38 7.525 7.571 1 7.993l5.006 4.26-1.645 6.456 5.632-3.565 5.632 3.565-1.645-6.455L19 7.993z",
  fill: "#F9B403"
});

var SvgStarGold = function SvgStarGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
};

export default SvgStarGold;